import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../components/AnimatedSection';
import './HeroSection.scss';
import heroBackground from '../../assets/images/hero/bg-hero.jpg';

const HeroSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 0.6, extra = {}) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 30, ...extra },
                  animate: { opacity: 1, y: 0, scale: 1 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    return (
        <section
            className="hero-section"
            style={{ '--hero-bg': `url(${heroBackground})` }}
        >
            <div className="hero-section__container">
                <div className="hero-section__content">
                    <motion.h1
                        className="hero-section__title"
                        {...fadeUp(0.5, 0.8, { scale: 0.97 })}
                    >
                        {t('hero_title')}
                    </motion.h1>
                    <motion.p
                        className="hero-section__subtitle"
                        {...fadeUp(0.9)}
                    >
                        {t('hero_subtitle')}
                    </motion.p>
                    <div className="hero-section__actions">
                        <motion.div {...fadeUp(1.2, 0.5)}>
                            <Link to="/join" className="button button--primary">
                                {t('join_in_person')}
                            </Link>
                        </motion.div>
                        <motion.div {...fadeUp(1.4, 0.5)}>
                            <a
                                href="https://uaregeneration.online.church/"
                                className="button button--outline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t('watch_online')}
                            </a>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
